import React from 'react';

import { Formik, Form as FormikForm } from 'formik';

import { Button, Modal } from '@shared/components/bootstrap';
import { FormikInputFormGroup } from '@shared/components/fields/formik/formik_input_form_group';
import { FormikSelectFormGroup } from '@shared/components/fields/formik/formik_select_form_group';

import { Landing__Location__Illustration, type Landing__Location__BenefitInput } from '@admin/schema';

const DEFAULT_ILLUSTRATION = Landing__Location__Illustration.Inventory;

export const LandingLocationBenefitModal: React.FC<{
  value?: Landing__Location__BenefitInput;
  onClose(): void;
  onSave(input: Landing__Location__BenefitInput): void;
}> = ({ value, onClose, onSave }) => {
  const onSubmit = (input: Landing__Location__BenefitInput) => {
    if (!input.title || !input.description || !input.alt) return;
    onSave(input);
  };

  return (
    <Modal onClose={onClose}>
      <Formik<Landing__Location__BenefitInput>
        initialValues={{
          title: value?.title ?? '',
          description: value?.description ?? '',
          alt: value?.alt ?? '',
          illustration: value?.illustration ?? DEFAULT_ILLUSTRATION,
        }}
        onSubmit={onSubmit}
      >
        <FormikForm>
          <Modal.Content>
            <Modal.Header>
              <Modal.Title>Benefit</Modal.Title>
              <Modal.Close close={onClose} />
            </Modal.Header>
            <Modal.Body>
              <FormikInputFormGroup id="title" name="title" label="Title:" />
              <FormikInputFormGroup id="description" name="description" label="Description:" />
              <FormikInputFormGroup id="alt" name="alt" label="Alt:" />
              <FormikSelectFormGroup id="illustration" name="illustration" label="Illustration:">
                <option value={Landing__Location__Illustration.Book}>Book</option>
                <option value={Landing__Location__Illustration.Boxes}>Boxes</option>
                <option value={Landing__Location__Illustration.Clock}>Clock</option>
                <option value={Landing__Location__Illustration.Inventory}>Inventory</option>
                <option value={Landing__Location__Illustration.Piggybank}>Piggy Bank</option>
                <option value={Landing__Location__Illustration.Truck}>Truck</option>
                <option value={Landing__Location__Illustration.Unit}>Unit</option>
              </FormikSelectFormGroup>
            </Modal.Body>
            <Modal.Footer>
              <Button type="submit" kind="primary">
                Save
              </Button>
            </Modal.Footer>
          </Modal.Content>
        </FormikForm>
      </Formik>
    </Modal>
  );
};
